import React from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { FontSizes } from "@/assets/fonts.ts";
import { Icons } from "@/assets/icons.ts";
import { Images } from "@/assets/images.tsx";
import { useStyles } from "@/hooks/useStyles.ts";
import type { Theme } from "@/theme/CreateTheme.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardFooter } from "@/uiKit/atoms/CardFooter.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";
import { Typography } from "@/uiKit/atoms/Typography.tsx";
import { LGCImportInfoDialog } from "@/uiKit/organisms/PatientSync/LGCImportInfoDialog.tsx";

export type LGCImportCardProps = {
  className?: string;
};

export const LGCImportCard: React.FC<LGCImportCardProps> = ({ className }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);

  return (
    <Card className={cx(styles.container, className)}>
      <CardHeader title={<Images.lgc alt="LGC" className={styles.logo} />} />
      <CardContent className={styles.content}>
        <Typography variant="subtitle">{t("patientSync.lgc.title")}</Typography>
        <Typography variant="body">{t("patientSync.lgc.subtitle")}</Typography>
      </CardContent>
      <CardFooter position="start">
        <Button
          variant="contained"
          data-action="sync.lgc.open-info"
          endIcon={<Icons.chevronRight className={styles.icon} />}
          onClick={() => setIsDialogOpen(true)}
        >
          {t("patientSync.lgc.connectSoftware")}
        </Button>
      </CardFooter>
      <LGCImportInfoDialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} />
    </Card>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({}),
  content: css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  }),
  logo: css({
    maxHeight: theme.spacing(32),
  }),
  icon: css({
    width: FontSizes.body,
    height: FontSizes.body,
  }),
});
